import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell, AuthField, AuthError } from "../components/AuthShell";
import { authResetPassword, formatApiErrorDetail } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await authResetPassword(token.trim(), password);
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Enter your reset token and a new password.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <AuthError message={error} />
        <AuthField label="Reset token" type="text" required value={token} onChange={(e) => setToken(e.target.value)} placeholder="Paste the token" data-testid="reset-token" />
        <AuthField label="New password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" data-testid="reset-password" />
        <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full h-11 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-sm font-semibold text-white flex items-center justify-center gap-2 transition-colors">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Update password
        </button>
        <p className="text-sm text-zinc-400 text-center"><Link to="/login" className="text-blue-400 hover:text-blue-300">Back to sign in</Link></p>
      </form>
    </AuthShell>
  );
}
